<template>
    <div @click.stop.prevent="showStopAppModal" class="w-100">
        <slot></slot>
    </div>
</template>

<script>
import { enumsData } from '@/mixins/enums'

export default {
    name: 'StopApplication',
    mixins: [enumsData],
    props: {
        app: Object,
        appName: String,
        sessionId: String,
        isShared: Boolean
    },
    methods: {
        showStopAppModal() {
            if ((this.app.aid && this.$route.query.stopAid !== this.app.aid) || (this.sessionId && this.$route.query.stopSessionId !== this.sessionId)) {
                this.$router.push({ query: { stopAid: this.app.aid, stopSessionId: this.sessionId } })
            }

            let message = `Are you sure you would like to stop application ${this.appName}?`
            if (this.isShared) {
                message = `Are you sure you would like to stop application ${this.appName}?<p class="my-2 font-weight-bold warning--text">This application allows multiple users to connect simultaneously, so stopping it might affect other users.</p> <p>It will stop automatically once idle.</p>`
            }

            const actions = ['stop-application', 'cancel']

            this.$store.dispatch('showGlobalDialog', {
                dialogText: message,
                dialogAction: actions,
                dialogTitle: 'Confirm application stop'
            })
        }
    },
    computed: {}
}
</script>
